<template>
    <div>
        <button
            @click="copy"
            class="ml-auto mr-0 flex justify-end items-center text-nutreance-green hover:text-nutreance-green-lighter"
        >
            {{ code }}
            <DuplicateIcon class="hidden sm:inline h-5 w-5 ml-1" />
        </button>
        <p
            v-if="success"
            class="flex justify-end items-center mt-1 text-sm text-nutreance-green"
        >
            <CheckCircleIcon class="h-5 w-5 mr-1" />
            Copied!
        </p>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { copyText } from "vue3-clipboard";
import { DuplicateIcon } from "@heroicons/vue/outline";
import { CheckCircleIcon } from "@heroicons/vue/solid";

const props = defineProps<{
    code?: string;
}>();

const success = ref(false);

function copy() {
    copyText(props.code, undefined, (error: any) => {
        if (!error) {
            success.value = true;
        }
    });
}
</script>
